import React from 'react';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import { IdentifierData } from '../../Reducers/App/types';
import { useStyles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedComponent } from '../../Reducers/App/Actions';
import { selectOption } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { ConfiguratorComponent } from '../Forms/types';
import { getDisabledOptions, getSelectedComponentWithOptions } from '../../Reducers/App/Selectors';
import OptionComment from './OptionComment';

interface SelectorItemProps {
  item: IdentifierData;
  component?: ConfiguratorComponent;
  isOption?: boolean;
}

const SelectorItem: React.FC<SelectorItemProps> = (props) => {
  const { item, isOption } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const component = useSelector(getSelectedComponentWithOptions);
  const selected = component?.selectedOptions.find((option) => option.identifier === item.identifier);
  const disabledOptions = useSelector(getDisabledOptions);

  const disabled = component?.active === false || disabledOptions.includes(item?.identifier);

  const selectItem = (item) => {
    if (isOption) {
      dispatch(
        setSelectedComponent({
          ...component,
          selectedOptions: { ...item },
        })
      );
      dispatch(selectOption({ ...item, amount: item.amount ? 0 : 1 }, false, false, component));
    } else {
      dispatch(setSelectedComponent(item));
    }
  };
  return (
    (!component || isOption) && (
      <>
        <div
          className={clsx(classes.row, classes.item, disabled && classes.disabled)}
          key={item.identifier}
          onClick={() => selectItem(item)}
        >
          <Typography className={clsx(selected ? 'selected' : '')}>{item.title}</Typography>
          {!isOption && <ChevronRight />}
        </div>
        {isOption && selected && <OptionComment component={component} variant={'configuration'} />}
      </>
    )
  );
};

export default SelectorItem;
